// Modules
import { useMemo } from 'react'
import { PhoneNumberType, PhoneNumberUtil } from 'google-libphonenumber'

// Helpers
import { checkIfURL } from 'helpers/format'

// Data (Local)
const specialCharacters = ['!', '"', '#', '$', '%', '&', '\'', '(', ')', '*', '+', ',', '-', '.', '/', ':', ';', '<', '=', '>', '?', '@', '[', '\\', ']', '^', '_', '`', '{', '|', '}', '~']
const phoneNumberUtility = PhoneNumberUtil.getInstance()

// Functions (Local)
function checkIfPhoneNumberIsValid (value) {
	try {
		return phoneNumberUtility.isValidNumber(phoneNumberUtility.parseAndKeepRawInput(value))
	} catch (error) {
		return false
	}
}
function checkIfMobilePhoneNumber (value) {
	try {
		const phoneNumberType = phoneNumberUtility.getNumberType(phoneNumberUtility.parseAndKeepRawInput(value))
		return phoneNumberType === PhoneNumberType.MOBILE || phoneNumberType === PhoneNumberType.FIXED_LINE_OR_MOBILE
	} catch (error) {
		return false
	}
}
function validate (rule, data, comparisonData) {
	switch (rule) {
		case 'hasAtLeast8Characters':
			return data?.toString().length >= 8
		case 'hasLowerCaseLetter':
			return /[a-z]/.test(data)
		case 'hasMatchingValue':
			return data === comparisonData
		case 'hasNonEmptyValue':
			return data?.length > 0
		case 'hasNumber':
			return /[0-9]/.test(data)
		case 'hasSpecialCharacter':
			return (
				data
					?.split('')
					?.some(character => specialCharacters.includes(character))
			) || false
		case 'hasUnusedValue':
			return Array.isArray(comparisonData) && !comparisonData.includes(data)
		case 'hasUpperCaseLetter':
			return /[A-Z]/.test(data)
		case 'isEmail':
			return /\S+@\S+\.\S+/.test(data)
		case 'isMobilePhoneNumber':
			return checkIfMobilePhoneNumber(data)
		case 'isPhoneNumber':
			return checkIfPhoneNumberIsValid(data)
		case 'isURL':
			return checkIfURL(data)
		case 'isPersonName':
			return data?.toString().length >= 2
		default:
			return !!rule ? true : false
	}
}

// Hook: Validation > Form controls
function useFormControls (rules, data, comparisonData) {
	// Data (Memoized)
	const issues = useMemo(() => {
		if (!rules || !Array.isArray(rules)) return []
		return rules.filter(rule => !validate(rule, data, comparisonData))
	}, [comparisonData, data, rules])
	const isValid = useMemo(() => !(issues.length > 0), [issues])

	// Response
	return { issues, isValid, specialCharacters }
}

// Export
export default useFormControls
